import { useEffect } from "react";
import { useFieldSet } from "./use-fieldset";
import { getStatusFromFieldset, DocumentStatus } from "./document-status";
import { usePortalProperty } from "./use-portal-property";

const setNoindexMeta = () => {
  const existingTag = document.querySelector('meta[name="robots"]');
  if (!existingTag) {
    const metaTag = document.createElement("meta");
    metaTag.name = "robots";
    metaTag.content = "noindex";
    document.head.appendChild(metaTag);
  }
};

const removeNoindexMeta = () => {
  const existingTag = document.querySelector('meta[name="robots"]');
  if (existingTag) {
    existingTag.remove();
  }
};

/**
 * For now the logic is very simple as this the first time we add robots metadata element to a page on the site
 * So code assume that no other places in codebase do we add or manipulate this element
 * @param hiveId
 * @param fullName
 */
export const useSetRobotsDirective = (hiveId: string, fullName: string) => {
  const { value: doNotIndexHistoricDocuments } = usePortalProperty<boolean>(
    "DoNotIndexHistoricDocuments"
  );
  const fieldSetData = useFieldSet(hiveId, fullName);

  useEffect(() => {
    if (!doNotIndexHistoricDocuments || !fieldSetData) {
      return;
    }

    const status = getStatusFromFieldset(fieldSetData);
    if (status === DocumentStatus.Historic) {
      setNoindexMeta();
    } else {
      removeNoindexMeta();
    }

    // Cleanup function to remove meta tag when component unmounts or dependencies change
    return () => {
      removeNoindexMeta();
    };
  }, [hiveId, fullName, fieldSetData, doNotIndexHistoricDocuments]);
};
